import { IsOptional, IsUUID } from 'class-validator';
import { BaseCreateDto, BaseDto } from '../base.dto';

export interface ConditionMarkerDto extends BaseDto {
  conditionId: string;
  /** @deprecated Use conditionId */
  skinConditionId?: string;
}

export class CreateConditionMarkerDto extends BaseCreateDto {
  @IsOptional()
  @IsUUID()
  conditionId?: string;

  @IsOptional()
  @IsUUID()
  /** @deprecated Use conditionId */
  skinConditionId?: string;
}
